import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

const EditRoleCellRenderer = ({
  value,
  onEditClick,
  onRemoveClick,
  data,
  canModify,
  editedRoleId,
  readOnly,
}) => {
  const onClickHandler = useCallback(() => {
    onEditClick(value);
  }, [onEditClick, value]);
  const onRemoveHandler = useCallback(() => {
    onRemoveClick(value);
  }, [onRemoveClick, value]);

  const disabled = !readOnly && editedRoleId !== value;
  const visible = (canModify && readOnly) || (editedRoleId !== value);

  return visible && (
    <div>
      { data.allowEdit === 'Y' && (
        <button
          className="cell-icon-button"
          title="Edit Role"
          onClick={onClickHandler}
          disabled={disabled}
        >
          <PencilIcon size={16} className="cell-icon disabled-visible"/>
        </button>)}
      {data.allowDelete === 'Y' && (
        <button
          className="cell-icon-button"
          title="Delete Role"
          onClick={onRemoveHandler}
          disabled={disabled}
        >
          <TrashIcon size={16} className="cell-icon disabled-visible"/>
        </button>)}
    </div>
  );
};

EditRoleCellRenderer.propTypes = {
  value: PropTypes.number.isRequired,
  isRoleModified: PropTypes.bool.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    allowDelete: PropTypes.string.isRequired,
    allowEdit: PropTypes.string.isRequired,
    clientId: PropTypes.number,
    description: PropTypes.string,
    roleName: PropTypes.string,
    privilegeList: PropTypes.arrayOf(PropTypes.string),
    roleId: PropTypes.number,
  }),
  editedRoleId: PropTypes.number,
  canModify: PropTypes.bool.isRequired,
};

export default EditRoleCellRenderer;
